export interface CommandSink<TCommand> {
  enqueue(command: TCommand): void;
}

/** The only mutation path from UI/input into a simulation. The dispatch
 * tap exists for the audio layer: sim events alone can't always
 * distinguish player intent. */
export class CommandBus<TCommand> {
  onDispatch: ((command: TCommand) => void) | null = null;

  private readonly sink: CommandSink<TCommand>;

  constructor(sink: CommandSink<TCommand>) {
    this.sink = sink;
  }

  dispatch(command: TCommand): void {
    this.onDispatch?.(command);
    this.sink.enqueue(command);
  }
}
